module.exports = __webpack_public_path__ + "static/assets/c40ccf288c211a9441bb714db775d334.mp3";